import { UseCase } from "src/app/core/utils/usecase";
import { UpdateClaimConciliatorEntity } from "../entities/update-claim-conciliator.entity";
import { Failure } from "src/app/core/utils/failure";
import { ClaimRepositoryBase } from "../repositories/claim-base.repository";
import { Injectable } from "@angular/core";

@Injectable()
export class UpdateClaimConciliatorUseCase implements UseCase<UpdateClaimConciliatorEntity, string | Failure> {
    constructor(private claimRepository: ClaimRepositoryBase) { }

    async execute(param: UpdateClaimConciliatorEntity): Promise<string | Failure> {
        return await this.claimRepository.updateClaimConciliator(param);
    }
}